export default "__VITE_ASSET__Cg3gB_0J__"